'use strict';
require('../CompanyService.js');
require('../customers/CompanyCustomersService.js');
require('../customers/categories/CompanyCustomerCategoriesService.js');
require('../customers/service-type/CompanyCustomerServiceTypeService.js');
CompanyCustomersDashboardCtrl.$inject = [
  '$scope',
  '$timeout',
  '$stateParams',
  '$state',
  'customerStatuses',
  'CompanyCustomersService',
  'customerCategories',
  'customerTypes',
  'CompanyUserService',
  'CompanyCustomerServiceTypeService'
];
function CompanyCustomersDashboardCtrl
(
  $scope,
  $timeout,
  $stateParams,
  $state,
  customerStatuses,
  customersService,
  customerCategories,
  customerTypes,
  CompanyUserService,
  CompanyCustomerServiceTypeService) {
  if (!$scope.info.features.customers || !$scope.info.features.extendCustomerManage || !$scope.currentUserPermissions.CompanyExtendCustomerList) {
    $state.go('root.company.403', {}, { location: false });
  }

  $scope.customerCategories = customerCategories;
  $scope.customerTypes = customerTypes;
  $scope.serviceTypes = [];
  if($scope.info.features.companyService){
    CompanyCustomerServiceTypeService.query({companyId: $scope.currentCompany.id, limit: 1000}).$promise.then(function(serviceTypes){
        $scope.serviceTypes = serviceTypes;
    });
  }

  $scope.customerStatuses = [];

  $scope.defaultAddress = {
    streetAddress: "",
    zipCode: "",
    city: ""
  };

  for (var i = 0; i < customerStatuses.length; i++) {
    if (customerStatuses[i].order > 0) {
      $scope.customerStatuses.push(customerStatuses[i]);
    }
  }

  $scope.queryManager = function(filter) {
    CompanyUserService.query({companyId: $scope.currentCompany.id, q: filter, limit: 6}).$promise.then(function(users){
        $scope.managers = users;
    });
  };
}

CompanyCustomersDashboardCtrl.resolve = {
  customerStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryCustomerStatus({companyId: $stateParams.companyId}).$promise;
  }],
  customerCategories: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
    return CompanyCustomerCategoriesService.query({
      companyId: $stateParams.companyId,
      type: 'CATEGORY',
      limit: 1000
    }).$promise;
  }],
  customerTypes: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
    return CompanyCustomerCategoriesService.query({
      companyId: $stateParams.companyId,
      type: 'TYPE',
      limit: 1000
    }).$promise;
  }]
};

module.exports = CompanyCustomersDashboardCtrl;

angular.module('dokiv')
  .controller('CompanyCustomersDashboardCtrl', CompanyCustomersDashboardCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customers-dashboard/CompanyCustomersDashboardCtrl.js
// module id = 335
// module chunks = 0